import angular from 'angular';

const modelsModule = angular.module('meredicte.models', []);

export default modelsModule;



// WEBPACK FOOTER //
// ./src/models/models.module.js